import {
  Box,
  DetailRow,
  H5,
  PhoneNumberText,
  RestaurantReferralSide,
  RestaurantReferralStatus,
  Separator,
  displayCentsInDollars,
  lightTheme,
} from '@vgrubs/components';
import { useNavigate } from 'react-router';

type Props = {
  /** "Referred by" or "New restaurant". */
  title: string;
  side: RestaurantReferralSide;
  status: RestaurantReferralStatus;
};

/** What a bonus is, in the tense the referral is in. */
const bonusLine = (amount: number, status: RestaurantReferralStatus) => {
  const money = displayCentsInDollars(amount);
  if (status === 'earned') return `${money} paid to the vGrubs balance`;
  if (status === 'expired') return `${money} was on offer, not paid`;
  return `${money} once the orders are in`;
};

/** One side of a referral: the restaurant, its owner, and its bonus. */
export const ReferralSideCard = ({ title, side, status }: Props) => {
  const navigate = useNavigate();

  return (
    <Box $flex $column>
      <DetailRow
        label={title}
        onOpen={() => navigate(`/locations/${side.locationId}`)}
      >
        <H5 $m="0" $color={lightTheme.primary}>
          {side.name}
        </H5>
      </DetailRow>
      <Separator $m="16px 0" />
      <DetailRow label="Owner">
        <H5 $m="0">{side.ownerName || '-'}</H5>
        {side.ownerPhone && <PhoneNumberText phone={side.ownerPhone} />}
      </DetailRow>
      <Separator $m="16px 0" />
      <DetailRow label="Bonus">
        <H5 $m="0" $color={status === 'earned' ? lightTheme.green : undefined}>
          {bonusLine(side.bonusAmount, status)}
        </H5>
      </DetailRow>
    </Box>
  );
};
